<template>
    <v-menu v-model="shows" top offset-y content-class="v-menu--tooltip">
        <template #activator="{attrs,on}">
            <v-hover v-model="shows">
                <slot name="activator" v-bind="{ attrs, on }" />
            </v-hover>
        </template>
        <v-card tile class="v-card--tooltip">
            <v-card-text>
                <p class="font-size-14 font-weight-medium primary--text mb-2">자동응찰이란?</p>
                <p class="font-size-14 grey-68--text">자동응찰가를 설정하면, 다른응찰에 <br/>대응하여 설정한 금액까지 자동 응찰됩니다.</p>
            </v-card-text>
        </v-card>
    </v-menu>
</template>

<script>
export default {
    data: () => ({ shows: false }),
};
</script>

<style></style>
